import axiosInstance from '../Config/AxiosInstance';

const PREFIX = `/clinic/reviewer`;

// Old implementation - commented out as backend sends all items by default
// export const listAll = (
//   facilities,
//   name,
//   pageSize,
//   pageNo,
//   sortFitler,
//   sortOrder
// ) => {
//   let url =
//     PREFIX +
//     `?name=${encodeURIComponent(
//       name
//     )}&sortKey=${sortFitler}&page=${pageNo}&size=${pageSize}&sortOrder=${sortOrder}`;
//   if (facilities.length > 0) {
//     url = url + `&facilityIds=${facilities}`;
//   }
//   return axiosInstance.get(url);
// };

// Simplified implementation - backend sends all items without pagination params
export const listAll = () => {
  return axiosInstance.get(PREFIX);
};

// Old implementation - commented out as backend sends all items by default
// export const listAllGroups = (
//   searchString,
//   pageSize,
//   pageNo,
//   sortFitler,
//   sortOrder
// ) => {
//   let url =
//     PREFIX +
//     `/group?page=${pageNo}&search=${searchString}&sortKey=${sortFitler}&size=${pageSize}&sortOrder=${sortOrder}`;
//
//   return axiosInstance.get(url);
// };

// Simplified implementation - backend sends all items without pagination params
export const listAllGroups = () => {
  return axiosInstance.get(PREFIX + '/group');
};
export const saveReviewer = data => {
  return axiosInstance.post(PREFIX, data);
};

export const editReviewer = data => {
  return axiosInstance.put(PREFIX, data);
};
export const saveReviewerGroup = data => {
  return axiosInstance.post(PREFIX + `/group`, data);
};

export const editReviewerGroup = data => {
  return axiosInstance.put(PREFIX + `/group`, data);
};
export const deleteReviewer = id => {
  return axiosInstance.delete(PREFIX + `/${id}`);
};

export const getReviewerJobs = (
  facilities,
  pageSize,
  pageNo,
  sortFitler,
  sortOrder,
  type,
  searchKey,
  jobStatus
) => {
  let url =
    PREFIX +
    `/job/${type}?&sortKey=${sortFitler}&page=${pageNo}&size=${pageSize}&sortOrder=${sortOrder}&searchValue=${searchKey}${
      jobStatus ? '&jobStatus=' + jobStatus : ''
    }`;
  return axiosInstance.get(url);
};

export const reviewerSelfAssignJob = (jobId, sessionId) => {
  return axiosInstance.put(
    PREFIX + `/job/${jobId}/assign?session-id=${sessionId}`
  );
};

export const startReviewerJob = jobId => {
  return axiosInstance.put(PREFIX + `/job/${jobId}/start`);
};
export const getListOfJobsReview = (
  page,
  size,
  sortKey,
  sortOrder,
  status,
  searchKey
) => {
  return axiosInstance.get(
    PREFIX +
      `/jobs-to-review?page=${page}&size=${size}&sortKey=${sortKey}&sortOrder=${sortOrder}&status=${status}&searchValue=${searchKey}`
  );
};
export const completeReviewerJob = (jobId, sessionId, sections) => {
  return axiosInstance.put(
    PREFIX + `/job/${jobId}/complete?session-id=${sessionId}`,
    { sections }
  );
};

export const rejectReviewerJob = (jobId, data, sessionId) => {
  return axiosInstance.put(
    PREFIX + `/job/${jobId}/reject?session-id=${sessionId}`,
    data
  );
};
export const reviewerGroupsEachLevel = level => {
  return axiosInstance.get(PREFIX + `/group/level?level=${level}`);
};
export const releaseReviewerJob = (jobId, sessionId) => {
  return axiosInstance.put(
    PREFIX + `/${jobId}/release?session-id=${sessionId}`
  );
};
